var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics_box",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"l_box"},[_c('div',{staticClass:"ico"},[_vm._t("icon")],2)]),_c('div',{staticClass:"r_box"},[_c('div',{staticClass:"count"},[_vm._t("default")],2),_c('div',{staticClass:"Label"},[_vm._t("label-right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }